import { render, staticRenderFns } from "./index.vue?vue&type=template&id=885981e2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=885981e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885981e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('885981e2')) {
      api.createRecord('885981e2', component.options)
    } else {
      api.reload('885981e2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=885981e2&scoped=true", function () {
      api.rerender('885981e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/broadcast/room/index.vue"
export default component.exports